import React from "react";
import styled from "@emotion/styled";
import { Link } from "../Link";
import { AccountTypeEnum, User } from "@ecologi/shared";

const BannerWrapper = styled.div`
  text-align: center;
  margin-top: 2rem;
`;

const Banner = styled.div`
  background-color: ${({ theme }) => theme.colors.mushroomLight};
  border-radius: 5px;
  display: inline-block;
  padding: 20px;
  text-align: center;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.forest};
  font-weight: bold;
  text-decoration: underline;
`;

export function hasIncompleteProfile(user: User): boolean {
  if (parseInt(user.picture) > -1) return true;
  if (!user.blurb) return true;
  if (!user.city) return true;

  if (
    user.isBusinessType &&
    user.accountType !== AccountTypeEnum.INDIVIDUAL &&
    user.accountType !== AccountTypeEnum.LIKELY_INDIVIDUAL &&
    !user.link
  )
    return true;

  return false;
}

export type CompleteProfileBannerProps = {
  user: User;
};

export function CompleteProfileBanner({ user }: CompleteProfileBannerProps) {
  if (!hasIncompleteProfile(user)) return null;

  return (
    <BannerWrapper>
      <Banner>
        <div>
          Visit your{" "}
          <StyledLink href="/account/settings">profile settings</StyledLink> to
          update your information
        </div>
        <div>(only you see this message)</div>
      </Banner>
    </BannerWrapper>
  );
}
